import React from 'react';
import { useLabels, usePrefs } from 'wsm-common-data';
import { promoPropTypes } from '../../utilities/commonPropTypes';
import templates from '../../templates';
import { isMobile4x3 } from '../../utilities/aspect';
import '../../global-sass/index.scss';
import { aR } from '../../global-constants';
import { useURLPrefs } from '../../hooks/useURLPrefs';

const PromoTypeLayer = ({
	carouselPosition,
	ctaLabel,
	ctaUrl,
	discountDisplay,
	incentive = {},
	isMobile,
	isVisible = true,
	promo,
	width
}) => {
	const {
		showIncentiveTitleCondition,
		showIncentiveTitleBodystyle,
		useIncentiveShortTitle
	} = usePrefs();
	const { collection, aspectRatio } = useURLPrefs();
	const labels = useLabels();
	const { type, couponCode, imageUrl, vehicleImages, globalVehicleId } =
		promo;
	const ctaButtonData = { ctaUrl, ctaLabel };
	const isMobile4x3Template = isMobile4x3(aspectRatio);
	const updatedAR = isMobile4x3Template ? aR.MOBILE_4X3 : aspectRatio;
	const isIncentive =
		typeof incentive === 'object' &&
		incentive !== null &&
		Object.keys(incentive).length > 0 &&
		incentive.constructor === Object;
	const { description, title } = isIncentive ? incentive : promo;
	let applicableVehicle;
	let promoTitle;

	if (isIncentive) {
		const { condition, error, shortTitle, trims, vehicleTrims } = incentive;

		if (
			globalVehicleId &&
			!error &&
			vehicleTrims &&
			vehicleTrims.length &&
			trims &&
			trims.length
		) {
			let trim;

			// Get the first vehicleTrimId in the list for the promo's globalVehicleId (incentive's vehicleTrims.vehicleId)
			const vehicleTrim = vehicleTrims.find(
				(val) => val.vehicleId === globalVehicleId
			);
			if (
				vehicleTrim &&
				vehicleTrim.vehicleTrimIds &&
				vehicleTrim.vehicleTrimIds.length
			) {
				const vehicleTrimId = vehicleTrim.vehicleTrimIds[0];
				if (vehicleTrimId) {
					// Get the trim information matching the vehicleTrimId
					trim = trims.reduce((acc, val) => {
						if (
							val.globalVehicleTrimIds &&
							val.globalVehicleTrimIds.includes(vehicleTrimId)
						) {
							return val;
						}
						return acc;
					}, null);
				}
			}

			if (trim) {
				// Give priority to incentive title or shortTitle, depending on preference
				promoTitle = useIncentiveShortTitle
					? shortTitle || title
					: title || shortTitle;

				// Create vehicle description for the title
				applicableVehicle =
					trim.year && trim.make && trim.model
						? `${trim.year} ${trim.make} ${trim.model}`
						: '';

				// Turn on additional title data with preferences
				if (showIncentiveTitleCondition === 'true') {
					applicableVehicle = `${labels.get(
						condition
					)} ${applicableVehicle}`;
				}
				if (showIncentiveTitleBodystyle === 'true') {
					applicableVehicle = `${applicableVehicle} ${trim.bodyStyle}`;
				}
			}
		} else {
			return null;
		}
	} else {
		promoTitle = title;
	}

	const Template = templates[collection][updatedAR];
	if (Template) {
		return (
			<Template
				applicableVehicle={applicableVehicle}
				carouselPosition={carouselPosition}
				ctaButtonData={ctaButtonData}
				couponCode={couponCode}
				description={description}
				discountDisplay={discountDisplay}
				imageUrl={imageUrl}
				isMobile={isMobile}
				isVisible={isVisible}
				incentive={incentive}
				promo={promo}
				title={promoTitle}
				type={type}
				width={width}
				vehicleImages={vehicleImages}
			/>
		);
	} else {
		return null;
	}
};

PromoTypeLayer.propTypes = promoPropTypes;

export default PromoTypeLayer;
